import { Injectable, OnDestroy } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { fetch } from '@nrwl/angular';

import * as StaffActions from './staff.actions';
import { catchError, map, mergeMap, switchMap, takeUntil } from 'rxjs/operators';
import { of, Subject } from 'rxjs';
import { StaffService } from 'services/staff.service';
import { OrgStaffUserInterface, OrgStaffUserInterfaceWithId } from '@sk/sk-interfaces';

@Injectable()
export class StaffEffects implements OnDestroy{
  unsubscribe$ = new Subject();



  queryStaff$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StaffActions.queryFireStoreStaff),
      takeUntil(this.unsubscribe$),
      switchMap(() => this.staffService.queryStateChangesStaff()),
      mergeMap(actions => actions),
      map(action => {
        if (action.payload.doc.exists) {
          const payload = {
            ...action.payload.doc.data() as OrgStaffUserInterface,
            id: action.payload.doc.id,
            exists: action.payload.doc.exists
          } as OrgStaffUserInterfaceWithId;
          // FireStore Events:  'added' | 'removed' | 'modified'
          switch (action.type) {
            case 'added':
              return StaffActions.fromFireStoreAddStaff({ staff: payload });
              break;
            case 'removed':
              return StaffActions.fromFireStoreRemoveStaff({ id: payload.id });
              break;
            case 'modified':
              return StaffActions.fromFireStoreModifyStaff({
                staff: payload
              });
              break;
          }
        }
      }),
      catchError((error) => {
        return of(StaffActions.queryFireStoreStaffError({
          error
        }));
      })
    )
  );


  updateStaff = createEffect(() =>
    this.actions$.pipe(
      ofType(StaffActions.updateStaff),
      switchMap(action => {
        return this.staffService.updateStaffWithId(action.changes, action.id);
      }),
      map(() => StaffActions.updateStaffSuccess({})
      ),
      catchError((error) => {
        return of(StaffActions.updateStaffError({
          error
        }));
      })
    )
  );


  addStaff$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StaffActions.addStaff),
      switchMap(action => {
        console.log('ADD', action);
        return this.staffService.addStaff(action.staff);
      }),
      map(() => StaffActions.addStaffSuccess({})),
      catchError((err: Error) => {
        console.error(err);
        if (err) {
          return of(StaffActions.addStaffError({ error: err }));
        }
      })
    )
  );

  constructor(private actions$: Actions,
              private staffService: StaffService) {
  }


  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
